<ng-template #logo>
    <shared-nav-bar-logo></shared-nav-bar-logo>
</ng-template>

<ng-template #ucp>
    <shared-nav-bar-ucp></shared-nav-bar-ucp>
</ng-template>

<nav class="nav-bar" directive-draw-offset directive-draw-offset-mobile [ngClass]="{'-no-background': !background}">
    <div class="nav-bar__wrapper wrapper">
        <div class="nav-bar__row row">

            <div class="nav-bar__col col -left">
                <ng-container *ngTemplateOutlet="left || logo || null"></ng-container>
            </div>

            <div class="nav-bar__col col -right">
                <ng-container *ngTemplateOutlet="right || ucp || null"></ng-container>
            </div>

        </div>
    </div>
</nav>